export default ({
  path: "/educators",
  name: "users",
  component: () => import("@/views/user/User.vue"),
  meta: {
    title: "Educators - Self-Assessment and Quality Improvement Planning Portal"
  },
  children: [
    {
      path: "dashboard",
      name: "user-dashboard",
      component: () => import("@/views/user/UserDashboard.vue"),
      meta: {
        protected: true,
        requiresService: true,
        requiresCentreDirector: true,
        title: "Educators - Self-Assessment and Quality Improvement Planning Portal"
      }
    },
    {
      path: "create",
      name: "user-create",
      component: () => import("@/views/user/UserCreate.vue"),
      meta: {
        protected: true,
        requiresService: true,
        requiresCentreDirector: true,
        title: "Educators - Self-Assessment and Quality Improvement Planning Portal"
      }
    }
  ]
})
